import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from '../utils/toast';

const AssessmentsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (!token || !userData) {
      toast.error('Please sign in to access Assessments');
      navigate('/signin');
      return;
    }
    
    const parsedUser = JSON.parse(userData);
    
    // Check access
    const allowedRoles = ['Super Admin', 'Exlva Admin', 'Admin', 'ExlvaAdmin', 'ExlvaAdminLite', 'Hospital Admin'];
    if (!allowedRoles.includes(parsedUser.role)) {
      toast.error('You don\'t have access to Assessments');
      navigate('/dashboard');
      return;
    }
    
    // Redirect directly to Question Bank
    navigate('/assessments/questions', { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    </div>
  );
};

export default AssessmentsPage;
